import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { ParameterChip } from '@/components/parameter/ParameterChip.jsx';
import { countSubsetNestings } from '@/helpers/parameter/parameterExceptions.js';

export const ParameterNestingCountField = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const nested = Array.isArray(record?.subsets) ? record.subsets : [];
    const count = countSubsetNestings(record);

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center', maxWidth: '200px' }}>
            <Typography variant='body1'>{count} </Typography>
            {nested.map(child => (
                <ParameterChip key={child.id} label={translate(`resources.parameter.subsetTypes.${child.type}`, { _: child.type || '—' })} />
            ))}
        </Box>
    );
};
